var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "corp2FAToggle",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.toActivate
        ? _vm.$t.__("popups.Corp2FAToggle.activate_company_dual_authentication")
        : _vm.$t.__("popups.Corp2FAToggle.disable_company_dual_authentication")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _vm.toActivate
                  ? [
                      _c(
                        "p",
                        {
                          staticClass:
                            "typographies-paragraph-medium-semibold m-0 mb-2"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "En activant la double authentification sur l'ensemble des comptes collaborateurs de votre société, la sécurité va être renforcée."
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "m-0 mb-3 typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Lors de la prochaine connexion de chacun de vos collaborateurs, il leur sera demandé de choisir une méthode d'authentification afin de finaliser l'activation de la double authentification sur leur compte"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  : [
                      _c(
                        "p",
                        {
                          staticClass:
                            "typographies-paragraph-medium-semibold m-0 mb-2"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "En désactivant la double authentification sur l'ensemble des comptes collaborateurs de votre société, la sécurité ne sera plus renforcée."
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "m-0 mb-3 typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Lors de la prochaine connexion non reconnue de chacun de vos collaborateurs, il ne leur plus sera demandé un code de sécurité sur la méthode d'authentification configurée."
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "m-0 gray-60 typographies-paragraph-medium-regular"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Besoin d'aide ?")) +
                        "\n                "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://help.sellsy.com/fr/articles/6178777-comment-fonctionne-la-double-authentification",
                          target: "_blank"
                        }
                      },
                      [
                        _c("span", { staticClass: "bold" }, [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("Consulter notre page dédiée."))
                          )
                        ])
                      ]
                    )
                  ]
                )
              ],
              2
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary",
                    size: "medium"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _vm.toActivate
                  ? _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__(
                          "popups.Corp2FAToggle.activate_dual_authentication"
                        ),
                        type: "primary",
                        loading: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.save(true)
                        }
                      }
                    })
                  : _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__(
                          "popups.Corp2FAToggle.disable_dual_authentication"
                        ),
                        type: "primary-destructive",
                        loading: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.save(false)
                        }
                      }
                    })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }